import { useEffect, useState } from 'react';
import api from '../lib/api';
import { VERTICALS as STATIC_VERTICALS } from '../constants/verticals';

let cache: string[] | null = null;
let inflight: Promise<string[]> | null = null;

async function fetchOnce(): Promise<string[]> {
  if (cache) return cache;
  if (inflight) return inflight;
  inflight = api.get('/verticals').then(r => {
    const data: string[] = r.data?.data || [];
    cache = data.length > 0 ? data : [...STATIC_VERTICALS];
    return cache;
  }).catch(() => {
    return [...STATIC_VERTICALS];
  }).finally(() => {
    inflight = null;
  });
  return inflight;
}

/**
 * Returns the live list of verticals (static + dynamically added by admin),
 * with a synchronous fallback to the hardcoded static list while loading.
 */
export function useVerticals(): string[] {
  const [list, setList] = useState<string[]>(cache || [...STATIC_VERTICALS]);
  useEffect(() => {
    let active = true;
    fetchOnce().then(d => { if (active) setList(d); });

    const onUpdate = () => {
      fetchOnce().then(d => { if (active) setList(d); });
    };
    window.addEventListener('orbit:verticals-updated', onUpdate);
    return () => {
      active = false;
      window.removeEventListener('orbit:verticals-updated', onUpdate);
    };
  }, []);
  return list;
}

export function invalidateVerticalsCache() {
  cache = null;
  window.dispatchEvent(new Event('orbit:verticals-updated'));
}
